<template>
    <v-dialog v-model="dialog" :width="1200" :transition="false" scrollable>
        <template v-slot:activator="{ on, attrs }">
            <slot name="button" v-bind="{ on, attrs }">
                <v-btn class="d-block d-md-none" small fab :class="connectionClass" v-bind="attrs" v-on="on" dark
                       depressed>
                    <v-icon>mdi-phone</v-icon>
                </v-btn>

                <v-btn class="d-none d-md-block" :class="connectionClass" v-bind="attrs" v-on="on" dark depressed>
                    <v-icon left>mdi-phone</v-icon>
                    <span>telefoon</span>
                </v-btn>
            </slot>
        </template>
        <v-card>
            <v-toolbar flat dark color="primary" max-height="64">
                <v-toolbar-title>Bellen</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pt-4">
                <v-row>
                    <v-col>
                        <History @call="selectedPhoneNumber" />
                    </v-col>
                    <v-divider vertical />
                    <v-col cols="4">
                        <v-row>
                            <v-col class="text-right">
                                <v-btn @click="checklist" color="secondary" small>Checklist</v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <BPhoneField ref="phoneNumberInputField"
                                             label="Telefoonnummer"
                                             v-model="phoneNumberInput"
                                             clearable
                                />
                            </v-col>
                        </v-row>
                        <PhoneNumbers v-model="phoneNumberInput" />
                        <v-row>
                            <v-col>
                                <v-btn block color="success" :disabled="calling || !connected" @click="call">
                                    <v-icon left>mdi-phone</v-icon>
                                    Bellen
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn color="secondary" outlined @click="dialog = false">Sluiten</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import BPhoneField from "@/components/General/Form/BPhoneField";
import clone from "lodash/clone";
import User from "@/models/User/User";
import History from '@/components/PhoneCall/Dialer/History';
import PhoneNumbers from "@/components/PhoneCall/Dialer/PhoneNumbers";
import PushNotification from "@/models/User/PushNotification";

export default {
    name: "PhoneCallDialer",
    components: {
        PhoneNumbers,
        BPhoneField,
        History,
    },
    sockets: {
        'phone:status'(status) {
            this.connected = status;
        },
        disconnect() {
            this.connected = false;
        },
        'call:pushed'(data) {
            if (data.from.user_id === User.loggedInUser().id) {
                this.calling = true;
            }
        },
        'call:ended'(data) {
            if (data.from.user_id === User.loggedInUser().id) {
                this.calling = false;
            }
        },
    },
    data() {
        return {
            connected: false,
            dialog: false,
            phoneNumberInput: '',
            calling: false,
        }
    },
    props: {
        phoneNumber: {
            type: String,
            default: '0031',
        },
    },
    computed: {
        connectionClass(){
            return this.connected ? 'primary':'red lighten-4'
        }
    },
    watch: {
        dialog(visible) {
            if (visible) {
                this.phoneNumberInput = clone(this.phoneNumber);
                setTimeout(() => {
                    this.$refs.phoneNumberInputField.$children[0].focus();
                }, 100);
            }
        }
    },
    methods: {
        checklist() {
            PushNotification.phoneChecklist();
        },
        selectedPhoneNumber(number) {
            this.phoneNumberInput = number;
            this.call();
        },
        call() {
            this.$socket.emit('user:call', {
                user_id: User.loggedInUser().id,
                target_number: this.phoneNumberInput
            });
            this.dialog = false;
        },
    },
}
</script>
